import {Directive, HostListener, input, OnInit, output} from '@angular/core';

@Directive({
  selector: '[octWindowWidthDetector]',
  standalone: true
})
export class WindowWidthDetectorDirective implements OnInit {
  /**
   * Allows external components to set the breakpoint value. Default is 1024.
   * Use this input to customize the screen width breakpoint
   */
  breakpoint = input(1024);
  readonly breakpointExceeded = output<boolean>();

  ngOnInit() {
    this.checkAndEmitBreakpointStatus(window.innerWidth);
  }

  @HostListener('window:resize')
  onResize() {
    this.checkAndEmitBreakpointStatus(window.innerWidth);
  }

  checkAndEmitBreakpointStatus(width: number) {
    this.breakpointExceeded.emit(width > this.breakpoint());
  }
}
